import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { BellRing, Send } from "lucide-react";
import { toast } from "sonner";

const LABELS = { domain: "Domain", license: "Lisans", cloud: "Bulut" };

export default function UpcomingExpiry() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    const load = () => api.get("/reminders/upcoming").then((r) => setItems(r.data)).catch(() => {});
    load();
    window.addEventListener("vaultops:refresh", load);
    return () => window.removeEventListener("vaultops:refresh", load);
  }, []);

  const sendNow = async () => {
    setSending(true);
    try {
      const { data } = await api.post("/reminders/send-now");
      toast.success(`${data.sent} admine hatırlatma gönderildi`);
    } catch {
      toast.error("Hatırlatma gönderilemedi");
    } finally {
      setSending(false);
    }
  };

  if (!items.length) return null;

  return (
    <div data-testid="upcoming-expiry-panel" className="mb-6 p-4 rounded-xl border border-amber-500/30 bg-amber-500/5">
      <div className="flex items-center justify-between gap-3 mb-3">
        <div className="flex items-center gap-2 text-amber-400 font-semibold text-sm">
          <BellRing className="w-4 h-4" /> Süresi yaklaşan {items.length} kayıt
        </div>
        {user?.role === "admin" && (
          <Button data-testid="send-reminder-now-button" size="sm" onClick={sendNow} disabled={sending}
            className="bg-amber-500 hover:bg-amber-400 text-slate-950 h-8">
            <Send className="w-3.5 h-3.5 mr-1.5" /> {sending ? "Gönderiliyor..." : "Şimdi e-posta gönder"}
          </Button>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        {items.map((i) => (
          <span key={i.title + i.expiry} className="font-mono text-xs px-2.5 py-1 rounded border border-slate-700 bg-slate-900/60 text-slate-300">
            {i.title} · {LABELS[i.category]} · <span className={i.days < 0 ? "text-rose-400" : "text-amber-400"}>
              {i.days < 0 ? "süresi geçti" : `${i.days} gün`}</span>
          </span>
        ))}
      </div>
      <div className="text-[11px] text-slate-500 mt-3">Adminlere her pazartesi 09:00'da otomatik özet gönderilir (domain/lisans 30 gün, bulut 70 gün önceden).</div>
    </div>
  );
}
